import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import { TYPOGRAPHY_18 } from 'theme/theme'

const Text = styled.div`
  ${TYPOGRAPHY_18}

  color: #505259;
  margin-bottom: 6px;
  text-align: justify;
  text-justify: inter-word;
`

function TypographyComponent ({ children }) {
  return (
    <Text>
      { children }
    </Text>
  )
}

export default TypographyComponent

TypographyComponent.propTypes = {
  children: PropTypes.any
}
